export default __webpack_public_path__ + "static/media/earth.8ce48009.svg";